import type {ActionReturn} from 'svelte/types/runtime/action';

// focus element once condition is true
export function focusOnMount(node: HTMLElement, shouldFocus: boolean): ActionReturn<boolean> {
    let wasElementFocused = false;

    if (shouldFocus) {
        focusElement();
    }

    return {
        update(updatedShouldFocus) {
            if (updatedShouldFocus && !wasElementFocused) {
                focusElement();
            }
        }
    }

    function focusElement() {
        node.focus();
        wasElementFocused = true;
    }
}